import TableCellPlugin from '@tiptap/extension-table-cell'
import './Table.scss'

export const TableCell = TableCellPlugin.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: 'border: 1px solid black; border-spacing: 0; padding: 5px',
        parseHTML: (element) => element.style?.cssText || '',
        renderHTML: (attributes) => ({ style: attributes['style'] }),
      },
    }
  },
})
